<template lang="html">
  <div class="shopify-create-store">
    <Guide
      width="small"
      :content="content"
      contentHeading="Complete Website Details"
      :closeLink="closeLink"
      :nextLink="nextLink"
      :previousLink="previousLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'AnalyticsSubmitDetails',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'analytics-settings',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    previousLink() {
      return {
        name: 'analytics-create-property',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'analytics-save-id',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
          <p>Fill in your website details and click the <strong>Continue</strong> button.</p>
        `
    }
  }
}
</script>

<style lang="sass">
  .shopify-guide
</style>
